import { render, staticRenderFns } from "./RoleCapabilitiesTable.vue?vue&type=template&id=0bb7e2b6&scoped=true&"
import script from "./RoleCapabilitiesTable.vue?vue&type=script&lang=js&"
export * from "./RoleCapabilitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb7e2b6",
  null
  
)

export default component.exports